import React from "react";
import { Outlet } from "react-router-dom";
import { SiteHeader, SiteFooter } from "./Chrome";

export default function SiteLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-offwhite text-navy">
      <SiteHeader />
      <main className="flex-1"><Outlet /></main>
      <SiteFooter />
    </div>
  );
}
